import { render, staticRenderFns } from "./BorrowVideoDialog.vue?vue&type=template&id=1d1988d7&"
import script from "./BorrowVideoDialog.vue?vue&type=script&lang=js&"
export * from "./BorrowVideoDialog.vue?vue&type=script&lang=js&"
import style0 from "./BorrowVideoDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports